import { takeLatest, all } from "redux-saga/effects";
import { GENERATE_TICKET } from "../constants/tickets";

import { generateTicketApi } from "../../apiCalls/tickets";

function* generateTicket(action) {
  try {
    const response = yield generateTicketApi(
      action.payload.data,
      action.payload.token
    );
    if (response.data.statusCode === 200) {
    }
  } catch (error) {}
}

export default function* ticketsSaga() {
  yield all([takeLatest(GENERATE_TICKET, generateTicket)]);
}
